import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
export type ILoginData = typeof initialState.loginData;
export type IThemeState = typeof initialState.themeState;
export type ICurrency = {
  _id: string;
  name: string;
  symbol: string;
  system_code: string;
  is_main: boolean;
  state?: string;
  [key: string]: any;
};

export type IOrganization = {
  _id: string;
  name: string;
  [key: string]: any;
};

const initialState = {
  isAuth: true,
  themeState: localStorage.getItem("theme") || "light",
  currencies: [] as ICurrency[],
  exchangeRates: [] as any[],
  organizations: [] as IOrganization[],
  loginData: {
    _id: "",
    firstName: "",
    lastName: "",
    phone_number: "",
    full_name: "",
    password: "",
    token: "",
    type: "",
    state: "",
    is_boss: false,
    role: {
      _id: "",
      name: "",
      product: false,
      product_create: false,
      product_update: false,
      product_delete: false,
      product_warehouse: false,
      write_off: false,
      write_off_create: false,
      write_off_cancel: false,
      transaction: false,
      transaction_income: false,
      transaction_expense: false,
      transaction_cancel: false,
      transaction_transfer: false,
      transaction_exchange: false,
      transaction_exchange_method: false,
      currency: false,
      currency_create: false,
      currency_update: false,
      currency_delete: false,
      payment_method: false,
      payment_method_create: false,
      payment_method_update: false,
      payment_method_delete: false,
      transaction_type: false,
      transaction_type_create: false,
      transaction_type_update: false,
      transaction_type_delete: false,
      supplier: false,
      supplier_create: false,
      supplier_update: false,
      supplier_delete: false,
      purchase: false,
      purchase_create: false,
      purchase_update: false,
      purchase_cancel: false,
      role: false,
      role_create: false,
      role_update: false,
      role_delete: false,
      employee: false,
      employee_create: false,
      employee_update: false,
      employee_delete: false,
      unit_of_measure: false,
      unit_of_measure_create: false,
      unit_of_measure_update: false,
      unit_of_measure_delete: false,
      reports: false,
      recon_act: false
    },
  },
};

const LoginSlice = createSlice({
  name: "login-data",
  initialState,
  reducers: {
    setLoginData(state, payload: PayloadAction<ILoginData>) {
      state.loginData = payload.payload;
      state.isAuth = true;
    },
    setThemeState(state, payload: PayloadAction<IThemeState>) {
      state.themeState = payload.payload;
      localStorage.setItem("theme", state.themeState);
    },
    logout(state) {
      state.isAuth = false;
      state.loginData = initialState.loginData;
      state.currencies = [];
      state.organizations = [];
    },
    setCurrencies(state, payload: PayloadAction<ICurrency[]>) {
      state.currencies = payload.payload;
    },
    setExchangeRates(state, payload: PayloadAction<any[]>) {
      state.exchangeRates = payload.payload;
    },
    setOrganizations(state, payload: PayloadAction<IOrganization[]>) {
      state.organizations = payload.payload;
    },
  },
});

export const { setLoginData, setThemeState, logout, setCurrencies, setExchangeRates, setOrganizations } = LoginSlice.actions;

export default LoginSlice.reducer;
